import deposit from "../../../assets/images/icon/wallet-in.png";
import Withdraw from "../../../assets/images/icon/wallet-out.png";
import verified from "../../../assets/images/icon/wallet-verify-count.png";
import emptyed from "../../../assets/images/icon/empty-wallet.png";

export const iconTypeBank = (key) => {
    let icon = {
        verifying_account: verified,
        emptyed: emptyed,
        deposit: deposit,
        withdrawal: Withdraw
    }
    const action = icon[key];
    return action ? action : emptyed;
}